module.exports = __webpack_public_path__ + "static/media/c-sharp.c5b653fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/validations/images/c-sharp.png
// module id = 611
// module chunks = 146